<div class="dialog-header">
  <h2 mat-dialog-title class="dialog-title">Top up wallet — {{ data.companyName }}</h2>
  <p class="dialog-subtitle">Credit this company's wallet after payment has been received out of band.</p>
</div>

<mat-dialog-content class="dialog-content">
  <app-error-banner [message]="errorMessage()" />

  <mat-form-field appearance="outline">
    <mat-label>Amount</mat-label>
    <input matInput type="number" min="0.0001" step="0.01" [(ngModel)]="amount" name="amount" />
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Note (optional)</mat-label>
    <input matInput [(ngModel)]="note" name="note" placeholder="Bank transfer ref INV-2026-0042" />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions" align="end">
  <button mat-stroked-button class="btn-cancel" (click)="cancel()" [disabled]="isSubmitting()">Cancel</button>
  <button mat-flat-button class="btn-submit" (click)="submit()" [disabled]="isSubmitting() || !canSubmit">
    @if (isSubmitting()) {
      <mat-icon class="spinner">progress_activity</mat-icon>
    }
    {{ isSubmitting() ? 'Crediting…' : 'Top up' }}
  </button>
</mat-dialog-actions>
